<div class="col-12">
  <div class="table-responsive applicants-details overflow-x-visible">
    <table class="table table-bordered user-table">
      <thead>
        <tr>
          <th scope="col">Image</th>
          <th scope="col">Name</th>
          <th scope="col">User</th>
          <th scope="col">Status</th>
          <th scope="col">Created At</th>
          <th scope="col">Actions</th>
        </tr>
      </thead>
      @if (!loading && !!organizations.length) {
        <tbody>
          @for (organization of organizations  | paginate: {itemsPerPage: organizationPerPage, currentPage: organizationPage, totalItems: organizationTotal}; track organization; let i = $index) {
            <tr class="client"
              >
              <td><img src="{{organization.logo}}" style="object-fit: cover"
                width="50" height="50"
                class=" rounded-circle"
              onerror="this.src='assets/images/placeholder.png'" alt=""></td>
              <td>{{organization.name | titlecase}}</td>
              <td>{{organization.user?.firstName || 'NA'}} {{organization.user?.lastName || ''}}</td>
              <td>{{organization.status === true ? 'Active' : 'InActive'}}</td>
              <td>{{organization.createdAt | date: 'mediumDate'}}</td>
              <td class="action">
                <div class="dropdown">
                  <button type="button" class="btn header-item waves-effect btn-dropdown" id="page-header-user-dropdown"
                    data-toggle="dropdown" aria-haspopup="true" aria-expanded="true">
                    <a class="   mr-3 text-primary py-2 text-nowrap">
                      View actions <i class="las mb-1 la-angle-down align-middle mr-0"></i></a>
                    </button>
                    <div class="dropdown-menu dropdown-menu-right animate slideIn side-menu-dropdown py-0 rounded-1">
                      <a class=" dropdown-item  text-primary border-bottom py-2 text-nowrap"
                        (click)="showModal(featureModal,'organization',organization)">
                        <i class="las la-eye mb-1 la-lg   align-middle mr-0"></i> View</a>
                        <a class=" dropdown-item  text-info border-bottom py-2 text-nowrap"
                          [routerLink]="'/organizations/update-organization'"
                          [queryParams]="{id: organization.id}">
                          <i class="las la-edit mb-1 la-lg  align-middle mr-0"></i> Edit</a>
                          <a class=" dropdown-item  text-danger py-2 text-nowrap "
                            (click)="remove(organization.id)">
                            <i class="las la-trash mb-1 la-lg  align-middle mr-0"></i> Delete</a>
                          </div>
                        </div>
                      </td>
                    </tr>
                  }
                </tbody>
              }

              @if (loading) {
                <tbody>
                  @for (q of loaders; track q; let qi = $index) {
                    <tr class="client">
                      <td>
                        <ngx-skeleton-loader [theme]="{ width:'50px',height: '50px', marginBottom: '0px'}"></ngx-skeleton-loader>
                      </td>
                      <td>
                        <ngx-skeleton-loader [theme]="{width:'100px', marginBottom: '0px'}"></ngx-skeleton-loader>
                      </td>
                      <td>
                        <ngx-skeleton-loader [theme]="{ width:'100px', marginBottom: '0px'}"></ngx-skeleton-loader>
                      </td>
                      <td>
                        <ngx-skeleton-loader [theme]="{width:'100px', marginBottom: '0px'}"></ngx-skeleton-loader>
                      </td>
                      <td>
                        <ngx-skeleton-loader [theme]="{width:'100px', marginBottom: '0px'}"></ngx-skeleton-loader>
                      </td>
                      <td>
                        <ngx-skeleton-loader [theme]="{width:'200px', marginBottom: '0px'}"></ngx-skeleton-loader>
                      </td>
                    </tr>
                  }
                </tbody>
              }
            </table>
            @if (!loading && !organizations.length) {
              <div class="d-flex align-items-center justify-content-center py-5">
                No organizations found
              </div>
            }
            @if (!loading && !!organizations.length) {
              <div class="float-right mt-3">
                <pagination-controls (pageChange)="pageChange($event)"></pagination-controls>
              </div>
            }
          </div>
        </div>


        <ng-template #featureModal>
          <div class="modal-header">
            <h5 class="modal-title">Organization details</h5>
            <button type="button" class="close " data-dismiss="modal" aria-label="Close" (click)="closeModal()">
              <span aria-hidden="true" class="">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="col-md-12 px-1">
              <div class="col-12 p-0">
                <div class="row ">
                  <div class="col-6 mb-2">
                    <p class="mb-0 text-muted">Organization Name</p>
                    <p class="fw-semibold text-orange mb-2 ml-1">{{selectedOrganization.name}}</p>
                  </div>
                  <div class="col-6 mb-2">
                    <p class="mb-0 text-muted">Organization Founder</p>
                    <p
                    class="fw-semibold text-orange mb-2 ml-1">{{selectedOrganization.user?.firstName || 'NA'}} {{selectedOrganization.user?.lastName || ''}}</p>
                  </div>
                  @if (selectedOrganization.logo) {
                    <div class="col-6 mb-3">
                      <p class="mb-1 text-muted">Organization Logo</p>
                      <img src="{{selectedOrganization.logo}}" style="object-fit: cover"
                        width="50" height="50"
                        class="ml-1 rounded-circle"
                        onerror="this.src='assets/images/placeholder.png'" alt="">
                      </div>
                    }
                    <div class="col-6 mb-2">
                      <p class="mb-0 text-muted">Cause of organization</p>
                      <p class="fw-semibold text-orange mb-2 ml-1">{{selectedOrganization.cause}}</p>
                    </div>
                    <div class="col-12">
                      <p class="mb-0 text-muted">About organization</p>
                      <p class="fw-semibold text-orange mb-2 ml-1">{{selectedOrganization.about}}</p>
                    </div>
                  </div>
                </div>

              </div>
            </div>
            <div class="modal-footer justify-content-end ">
              <button type="button" class="btn btn-default" data-dismiss="modal" (click)="closeModal()">Close</button>
            </div>
          </ng-template>
